import { Button } from "@/components/ui/Button";

/** An unavailable diagnostic is never presented as an empty or healthy system. */
export function PlatformQueryNotice({
  pending,
  error,
  label,
  retry,
}: {
  pending: boolean;
  error: unknown;
  label: string;
  retry: () => unknown;
}) {
  if (!pending && !error) return null;
  return (
    <div className="platform-panel" role={error ? "alert" : "status"}>
      <p className={error ? "text-destructive-text" : "text-ink-muted"}>
        {error ? `Could not load ${label}.` : `Loading ${label}…`}
      </p>
      {error ? (
        <Button variant="ghost" onClick={() => void retry()}>
          Retry
        </Button>
      ) : null}
    </div>
  );
}
